import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {omit} from "@pg-mono/nodash";
import {appendQueryString} from "@pg-mono/request";
import {enable302ResponseState} from "@pg-mono/response-state";
import {rpAppLink} from "@pg-mono/rp-routes";

import {abTestingInstance} from "../../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../../ab_testing/ongoing_ab_tests";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {Country} from "../../../region/types/Country";
import {getCountryId} from "../helpers/sub_type/get_fetch_offer_list_subfilter_query";

export const redirectFromListToMap = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch) => {
    const abTestProps = abTestingInstance.getABTestContainerProps(OngoingABTests.MAP_AS_MAIN_VIEW);

    const cookiesObject = ctx.req?.cookies;
    const variantString = cookiesObject && cookiesObject[abTestProps.id];
    const parsedVariant = variantString && Number(variantString);

    const query = ctx.route.query;
    const friendlySlug = ctx.match.params.friendlySlug;

    const country = ctx.match.params.country;
    const abroadRegionSlug = ctx.match.params.abroadRegionSlug;

    const hasUserSelectedList = query.sol && query.sol === "true";
    const redirectQuery = omit(query, ["sol"]);

    if (parsedVariant && !isNaN(parsedVariant) && parsedVariant === 1 && !hasUserSelectedList) {
        if (country && getCountryId(country) !== Country.POLAND && friendlySlug) {
            const abroadLnk = abroadRegionSlug ? rpAppLink.offer.mapAbroadRegion : rpAppLink.offer.mapAbroadCountry;
            const abroadUrl = appendQueryString(
                abroadLnk({
                    friendlySlug,
                    country,
                    abroadRegionSlug
                }),
                redirectQuery
            );
            dispatch(enable302ResponseState(abroadUrl));
            return false;
        }

        if (friendlySlug) {
            const url = appendQueryString(rpAppLink.offer.mapFriendly({friendlySlug}), redirectQuery);
            dispatch(enable302ResponseState(url));
            return false;
        }

        dispatch(enable302ResponseState(appendQueryString(rpAppLink.offer.multiListMap(), redirectQuery)));
        return false;
    }

    return true;
};
import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {omit} from "@pg-mono/nodash";
import {appendQueryString} from "@pg-mono/request";
import {enable302ResponseState} from "@pg-mono/response-state";
import {rpAppLink} from "@pg-mono/rp-routes";

import {abTestingInstance} from "../../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../../ab_testing/ongoing_ab_tests";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {Country} from "../../../region/types/Country";
import {getCountryId} from "../helpers/sub_type/get_fetch_offer_list_subfilter_query";

export const redirectFromListToMap = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch) => {
    const abTestProps = abTestingInstance.getABTestContainerProps(OngoingABTests.MAP_AS_MAIN_VIEW);

    const cookiesObject = ctx.req?.cookies;
    const variantString = cookiesObject && cookiesObject[abTestProps.id];
    const parsedVariant = variantString && Number(variantString);

    const query = ctx.route.query;
    const friendlySlug = ctx.match.params.friendlySlug;

    const country = ctx.match.params.country;
    const abroadRegionSlug = ctx.match.params.abroadRegionSlug;

    const hasUserSelectedList = query.sol && query.sol === "true";
    const redirectQuery = omit(query, ["sol"]);

    if (parsedVariant && !isNaN(parsedVariant) && parsedVariant === 1 && !hasUserSelectedList) {
        if (country && getCountryId(country) !== Country.POLAND && friendlySlug) {
            const abroadLnk = abroadRegionSlug ? rpAppLink.offer.mapAbroadRegion : rpAppLink.offer.mapAbroadCountry;
            const abroadUrl = appendQueryString(
                abroadLnk({
                    friendlySlug,
                    country,
                    abroadRegionSlug
                }),
                redirectQuery
            );
            dispatch(enable302ResponseState(abroadUrl));
            return false;
        }

        if (friendlySlug) {
            const url = appendQueryString(rpAppLink.offer.mapFriendly({friendlySlug}), redirectQuery);
            dispatch(enable302ResponseState(url));
            return false;
        }

        dispatch(enable302ResponseState(appendQueryString(rpAppLink.offer.multiListMap(), redirectQuery)));
        return false;
    }

    return true;
};
